import { userRequest, BASE_URL } from "../requestMethods";
import { toast } from "react-toastify";

import { addToCart } from "./cart";

import {
  addProductToWishStart,
  addProductToWishSuccess,
  addProductToWishFailure,
  removeProductToWishStart,
  removeProductToWishSuccess,
  removeProductToWishFailure,
  getWishListStart,
  getWishListSuccess,
  getWishListFailure,
} from "../redux/wishListRedux";

export const getWishListData = async (dispatch, userId, no) => {
  console.log("get art data running", no);
  dispatch(getWishListStart());
  try {
    const res = await userRequest.get(
      `${BASE_URL}wishlist/getWishListFromUser/${userId}`
    );
    dispatch(getWishListSuccess(res.data.data));
  } catch (err) {
    dispatch(getWishListFailure());
  }
};

export const addToWishList = async (dispatch, userId, obj) => {
  console.log(obj, "dispatch");

  dispatch(addProductToWishStart());
  try {
    const res = await userRequest.post(
      `${BASE_URL}wishlist/addToWishList/?userId=${userId}`,
      obj
    );
    console.log(res.data, "wish list details");
    toast.success(`🦄 ${res.data.message}`);
    dispatch(addProductToWishSuccess(res.data));
    getWishListData(dispatch, userId, "runn 2");
  } catch (err) {
    dispatch(addProductToWishFailure());
  }
};

export const moveToCart = async (dispatch, userId, list) => {
  try{
    const obj = {
      productId: list?.productId?._id,
      categoryId: list?.categoryId?.map((x) => x._id),
      quantity: list?.quantity,
      color: list?.color,
      size: list?.size,
    };
    console.log(list, 'obj')
    addToCart(dispatch, userId, obj);
  
    dispatch(removeProductToWishStart());
    const res = await userRequest.post(
      `${BASE_URL}wishlist/removeFromWishList/?userId=${userId}&listId=${list._id}`
    );
    dispatch(removeProductToWishSuccess(res.data.data));
    getWishListData(dispatch, userId, "runn 1");
  }
  catch(err){
    dispatch(removeProductToWishFailure());
    console.log(err, "err");
  }
};

export const removeFromCart = async (
  dispatch,
  userId,
  cartId,
  successRemove
) => {
  dispatch(removeProductToWishStart());
  try {
    const res = await userRequest.post(
      `${BASE_URL}cart/removeFromCart/?userId=${userId}&cartId=${cartId}`
    );
    console.log(res.data.data, "remove from cart ");
    dispatch(removeProductToWishSuccess(res.data.data));
    getWishListData(dispatch, userId, "runn 1");
    successRemove();
  } catch (err) {
    dispatch(removeProductToWishFailure());
    console.log(err, "err");
  }
};

export const emptyCart = async (dispatch, userId) => {
  try {
    const res = await userRequest.post(
      `${BASE_URL}cart/emptyCart/?userId=${userId}`
    );
    // console.log(res, 'res data for remove cart')
    getWishListData(dispatch, userId);
  } catch (err) {
    console.log("err at empty cart", err);
  }
};
